import React from "react";
import { useTheme, Box, AtlasButton } from "@fuegokit/react";
import { AfDayIcon, AfNightIcon } from "@fuegokit/fuegoicons-react";

function ColorModeToggle() {
  const { colorMode, setColorMode } = useTheme();

  return (
    <AtlasButton
      appearance="subtle"
      aria-label={`Switch to ${
        colorMode === "night" ? "day" : "night"
      } color mode`}
      onClick={() => setColorMode(colorMode === "night" ? "day" : "night")}
      spacing="default"
    >
      <Box display="flex">
        {colorMode === "night" ? (
          <AfDayIcon size="small" />
        ) : (
          <AfNightIcon size="small" />
        )}
      </Box>
    </AtlasButton>
  );
}

export default ColorModeToggle;
